import React, { useEffect } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    TextField
} from '@mui/material';
import { useForm } from 'react-hook-form';

const AdminCompanyEditDialog = ({ open, onClose, company, onSave }) => {
    const {
        register,
        handleSubmit,
        reset,
        formState: { isSubmitting }
    } = useForm({
        defaultValues: {
            title: '',
            website: '',
            phone_number: '',
            manager_name: '',
            number_of_employees: '',
            address: '',
            city: '',
            description: '',
            country: ''
        }
    });

    useEffect(() => {
        if (company) {
            reset({
                title: company.title ?? '',
                website: company.website ?? '',
                phone_number: company.phone_number ?? '',
                manager_name: company.manager_name ?? '',
                number_of_employees: company.number_of_employees ?? '',
                address: company.address ?? '',
                city: company.city ?? '',
                description: company.description ?? '',
                country: company.country?.id ?? company.country ?? ''
            });
        }
    }, [company, reset, open]);

    const onSubmit = async (values) => {
        const payload = {
            ...values,
            country: values.country ? Number(values.country) : null
        };
        await onSave(payload);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Edit company</DialogTitle>
            <DialogContent dividers>
                <Stack spacing={2} sx={{ mt: 1 }}>
                    <TextField label="Company name" fullWidth {...register('title')} />
                    <TextField label="Website" fullWidth {...register('website')} />
                    <TextField label="Description" fullWidth multiline minRows={2} {...register('description')} />
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <TextField label="Phone number" fullWidth {...register('phone_number')} />
                        <TextField label="Manager name" fullWidth {...register('manager_name')} />
                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <TextField label="Team size" fullWidth {...register('number_of_employees')} />
                        <TextField label="Country ID" type="number" fullWidth {...register('country')} />
                    </Stack>
                    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <TextField label="City" fullWidth {...register('city')} />
                        <TextField label="Address" fullWidth {...register('address')} />
                    </Stack>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="inherit">
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmit(onSubmit)}
                    variant="contained"
                    disabled={isSubmitting}
                >
                    {isSubmitting ? 'Saving…' : 'Save changes'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AdminCompanyEditDialog;

